import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getMessaging, getToken } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const analytics = getAnalytics(app);
export const db = getFirestore(app);
export const messaging = getMessaging(app);
export { getToken };

function requestPermission() {
  Notification.requestPermission().then((permission) => {
    if (permission === 'granted') {
      getToken(messaging, {
        vapidKey:
          'BCYuG_nRCOl_BwE5BbfrVM_1BhQ4Hg4Zt_ooZaCITFV6okaeTSK0fhazjaJnmADSOK6NFmQTQAbjZpB7IbCCd9Q',
      })
        .then((token) => {
          if (token) {
          } else {
            console.log(
              'No registration token available. Request permission to generate one.'
            );
          }
        })
        .catch(() => {});
    } else {
      console.log('Unable to get permission to notify.');
    }
  });
}

requestPermission();

export default app;
